import { ScheduleEntry } from "../../types";

export const VIEW_SCHEDULE_ENTRY = 'SCHEDULE/VIEW_SCHEDULE_ENTRY';

export interface ScheduleDispatchTypes {
  type: string;
  payload?: any;
}